import React from 'react';
import { Spinner } from 'react-bootstrap';

const loadingIndicator = (props) => {
  const {type, animation, variant, size} = props;

  return (
    <div className={`loading-indicator text-center ${type}`}>
      <Spinner animation={animation} variant={variant} size={size} />
    </div>
  );
};

loadingIndicator.defaultProps = {
  type: 'inline',
  variant: 'dark',
  animation: 'border',
};

export default loadingIndicator;
